
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zh/guidelines",
      function () {
        return require("private-next-pages/zh/guidelines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zh/guidelines"])
      });
    }
  